import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  memberCode: null,
};

const entranceCounselorSlicer = createSlice({
  name: 'entranceCounselor',
  initialState,
  reducers: {
    setCounselorMemberCode: (state, action) => {
      state.memberCode = action.payload;
    },
    resetCounselorMemberCode: (state) => {
      state.memberCode = null;
    },
  },
});

export const { setCounselorMemberCode, resetCounselorMemberCode } =
  entranceCounselorSlicer?.actions;
export default entranceCounselorSlicer.reducer;
